import styled from 'styled-components';
import { BP_MOBILE_MAX, BP_TABLET_MAX } from '../../assets/styles/breakpoints';

export default styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  @media (max-width: ${BP_TABLET_MAX}px) {
    max-width: 560px;
    margin: 0 auto;
  }
  @media (max-width: ${BP_MOBILE_MAX}px) {
    max-width: 100%;
    margin: 0 auto;
  }
`;

export const TopContentWrapSC = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 32px;
  width: 100%;
`;

export const BottomContentWrapSC = styled.div`
  width: 100%;
`;

export const EmptySC = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 500px);
`;
